<template>
  <crud-form
    v-model="payload"
    :page-title="getSectionPageTitle"
    navigate-back-route="secao.list"
    navigate-page-after-save="secao.list"
    :request-class="requestClass"
    :total-group="1"
  >
    <template slot="group-1">
      <form-group title="Informação da seção">
        <v-row>
          <v-col
            v-if="payload.id"
            cols="6"
          >
            <input-text
              id="input:id"
              v-model="payload.id"
              label="Código"
              disabled
            />
          </v-col>
          <v-col cols="6">
            <input-text
              id="input:nomSecao"
              v-model="payload.nomSecao"
              label="Nome seção"
              :rules="[requiredRule]"
              required
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import ProdutoSecaoRequest from './ProdutoSecaoRequest';

export default {
  name: 'ProdutoSecaoForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: ProdutoSecaoRequest,
    payload: {
      nomSecao: '',
    },
  }),
  computed: {
    getSectionPageTitle() {
      return this.$route.params.id ? 'Editar seção' : 'Adicionar seção';
    },
  },
};
</script>
